import {
    IAppTimezonesSetAction,
    IAppSetConnectionIssueAction,
    IAppSetLoadingAction,
    IAppSetVisibilityAction,
} from 'models';
import {KnownVisibilityStates} from 'react-page-visibility';

export enum EAppTypes {
    APP_META_DATA_TIMEZONES_GET = 'APP/META/DATA/TIMEZONES/GET/SAGA',
    APP_META_DATA_TIMEZONES_SET = 'APP/META/DATA/TIMEZONES/SET/ACTION',
    APP_SET_CONNECTION_ISSUE_ACTION = 'APP/SET/CONNECTION/ISSUE/ACTION',
    APP_LOADING_ACTION = 'APP/LOADING/ACTION',
    APP_SET_VISIBILITY_ACTION = 'APP/SET/VISIBILITY/ACTION',
}

export interface IAppState {
    // * True while API requests are failing to reach the server; drives the
    // * reconnecting banner. Only `language` is persisted, so this resets on reload.
    connectionIssue: boolean;
    data: {
        timezones: string[] | undefined;
    };
    loading: boolean;
    appVisibility: {
        isVisible: boolean;
        visibilityState: KnownVisibilityStates;
    };
}

export type TAppActionTypes =
    | IAppTimezonesSetAction
    | IAppSetConnectionIssueAction
    | IAppSetLoadingAction
    | IAppSetVisibilityAction;
